import { useQuery } from "@tanstack/react-query";
import { getErroredEncounters, type GetErroredEncountersOptions } from "@/api/writeBackManagement";

export function useErroredWriteBacks(options?: GetErroredEncountersOptions, enabled = true) {
  return useQuery({
    queryKey: ["errored-write-backs", options],
    queryFn: () => getErroredEncounters(options),
    staleTime: 30_000,
    enabled,
  });
}
